import { Injectable } from '@angular/core';
import { AlertProvider } from './alert';
import { LoadingProvider } from './loading';
import { UserProvider } from './user';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { MediaCapture } from '@ionic-native/media-capture';
import { File } from '@ionic-native/file';
import { ToastController,Platform, AlertController } from 'ionic-angular';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import {TeamappProvider} from "./teamapp";

@Injectable()
export class ImageProvider {
  // Image Provider
  // This is the provider class for most of the image processing including uploading images to Firebase.
  // Take note that the default function here uploads the file in .jpg. If you plan to use other encoding types, make sure to
  // set the encodingType before uploading the image on Firebase.
  // Example for .png:
  // data:image/jpeg;base64 -> data:image/png;base64
  // generateFilename to return .png
  private profilePhotoOptions: CameraOptions = {
      quality: 50,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      correctOrientation: true,
      allowEdit: false,
      mediaType: 0,
  };

  private photoMessageOptions: CameraOptions = {
    quality: 50,
    destinationType: this.camera.DestinationType.DATA_URL,
    encodingType: this.camera.EncodingType.JPEG,
    correctOrientation: true,
    allowEdit: false,
    mediaType: 0,
  };

  private groupPhotoOptions: CameraOptions = {
    quality: 50,
    targetWidth: 384,
    targetHeight: 384,
    destinationType: this.camera.DestinationType.DATA_URL,
    encodingType: this.camera.EncodingType.JPEG,
    correctOrientation: true,
    allowEdit: false,
    mediaType: 0
  };
  // All files to be uploaded on Firebase must have DATA_URL as the destination type.
  // This will return the imageURI which can then be processed and uploaded to Firebase.
  // For the list of cameraOptions, please refer to: https://github.com/apache/cordova-plugin-camera#module_camera.CameraOptions

  constructor(private toastCtrl: ToastController, private alertCtrl: AlertController, public platform: Platform, public alertProvider: AlertProvider, public userProvider: UserProvider, public loadingProvider: LoadingProvider, public camera: Camera, public mediaCapture: MediaCapture, public file: File, private transfer: FileTransfer, public teamappProvider: TeamappProvider) {
    console.log("Initializing Image Provider");
  }

  // Function to convert dataURI to Blob needed by Firebase
  imgURItoBlob(dataURI) {
    var binary = atob(dataURI.split(',')[1]);
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    var array = [];
    for (var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], {
      type: mimeString
    });
  }

  // Generate a random filename of length for the image to be uploaded
  generateFilename() {
    var length = 8;
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text + ".jpg";
  }

  // Set ProfilePhoto given the user and the cameraSourceType.
  // This function processes the imageURI returned and uploads the file on Firebase,
  // Finally the user data on the database is updated.
  setProfilePhoto(user, sourceType) {
    this.profilePhotoOptions.sourceType = sourceType;

    this.uploadPhotoToChatServer(sourceType).then((url) => {
        this.teamappProvider.http_request('action=change_profile_image&image_url='+url, 'settings', false, true).then(data  => {
            this.userProvider.setUserImage(url);
            console.log(url);
        });
    });
  }

    setGroupPhoto(group, sourceType) {
        //this.profilePhotoOptions.sourceType = sourceType;
        return new Promise(resolve => {
            let urlRet = '';
            this.uploadPhotoToChatServer(sourceType).then((url) => {
                this.teamappProvider.http_request('action=set_group_image&image_source='+url+'&single_target='+group, 'chat', false, true).then(data  => {
                    urlRet = url;
                    resolve(urlRet);
                });
            });

        });
    }

  // Set group photo and return the group object as promise.
  setGroupPhotoPromise(group, sourceType): Promise<any> {
    return new Promise(resolve => {
      this.groupPhotoOptions.sourceType = sourceType;
      this.loadingProvider.show();
      // Get picture from camera or gallery.
      this.camera.getPicture(this.groupPhotoOptions).then((imageData) => {
        // Process the returned imageURI.
        let imgBlob = this.imgURItoBlob("data:image/jpeg;base64," + imageData);
        let metadata = {
          'contentType': imgBlob.type
        };

      }).catch((error) => {
        this.loadingProvider.hide();
      });
    });
  }

  //Delete the image given the url.
  deleteImageFile(path) {
    var fileName = path.substring(path.lastIndexOf('%2F') + 3, path.lastIndexOf('?'));

  }

  //Delete the user.img given the user.
  deleteUserImageFile(user) {
    var fileName = user.img.substring(user.img.lastIndexOf('%2F') + 3, user.img.lastIndexOf('?'));

  }

  // Delete group image file on group storage reference.
  deleteGroupImageFile(groupId, path) {
    var fileName = path.substring(path.lastIndexOf('%2F') + 3, path.lastIndexOf('?'));

  }

  // Upload photo message and return the url as promise.
  uploadPhotoMessage(conversationId, sourceType): Promise<any> {
    return new Promise(resolve => {
      this.photoMessageOptions.sourceType = sourceType;
      this.loadingProvider.show();
      // Get picture from camera or gallery.
      this.camera.getPicture(this.photoMessageOptions).then((imageData) => {
        // Process the returned imageURI.
        let imgBlob = this.imgURItoBlob("data:image/jpeg;base64," + imageData);
        let metadata = {
          'contentType': imgBlob.type
        };

        // Generate filename and upload to Firebase Storage.

      }).catch((error) => {
        this.loadingProvider.hide();
      });
    });
  }

    uploadPhotoToChatServer(sourceType): Promise<any> {
        return new Promise(resolve => {
            this.photoMessageOptions.sourceType = sourceType;
            this.loadingProvider.show();
            // Get picture from camera or gallery.
            this.camera.getPicture(this.photoMessageOptions).then((imageData) => {
                // Process the returned imageURI.
                // Generate filename and upload to Firebase Storage.
                this.teamappProvider.http_request('action=upload_image&image_source='+imageData, 'chat', false, true).then(data  => {
                    let url: any = data;
                    resolve(url.url);
                });

            }).catch((error) => {
                this.loadingProvider.hide();
            });
        });
    }

  // Upload group photo message and return a promise as url.
  uploadGroupPhotoMessage(groupId, sourceType): Promise<any> {
    return new Promise(resolve => {
      this.photoMessageOptions.sourceType = sourceType;
      this.loadingProvider.show();
      // Get picture from camera or gallery.
      this.camera.getPicture(this.photoMessageOptions).then((imageData) => {
        // Process the returned imageURI.
        let imgBlob = this.imgURItoBlob("data:image/jpeg;base64," + imageData);
        let metadata = {
          'contentType': imgBlob.type
        };
        // Generate filename and upload to Firebase Storage.

      }).catch((error) => {
        this.loadingProvider.hide();
      });
    });
  }

    uploadVideoToChatServer(): Promise<any> {
        return new Promise(resolve => {
            this.loadingProvider.show();
            this.mediaCapture.captureVideo().then( data => {
                let videoUrl = 'file://' +data[0].fullPath;
                if(this.platform.is('ios')) {
                    videoUrl = 'file://' +data[0].fullPath;
                } else {
                    videoUrl = data[0].fullPath;
                }
                console.log("video path: "+videoUrl);
                let x = videoUrl.split("/");
                let filepath = videoUrl.substring(0,videoUrl.lastIndexOf("/"));
                let name = x[x.length-1];
                console.log(filepath + " - "+ name);
                this.file.readAsDataURL(filepath, name).then( success => {
                    /*console.log(success);
                    let blob = new Blob([success], {type: "video/mp4"});
                    console.log(blob);*/
                    console.log(success);
                    this.teamappProvider.http_request('action=upload_video&image_source='+success, 'chat', false, true).then(data  => {
                        let url: any = data;
                        resolve(url.url);
                    });
                });


            }, err => {
                this.loadingProvider.hide();
                console.log("Media Err = "+err);
            });
        });
    }
  uploadGroupVideoMessage(groupId): Promise<any> {
    return new Promise(resolve => {
      this.loadingProvider.show();
          this.mediaCapture.captureVideo().then( data => {
              let videoUrl = 'file://' +data[0].fullPath;
              if(this.platform.is('ios')) {
                  videoUrl = 'file://' +data[0].fullPath;
              } else {
                  videoUrl = data[0].fullPath;
              }
              console.log("video path: "+videoUrl);
              let x = videoUrl.split("/");
              let filepath = videoUrl.substring(0,videoUrl.lastIndexOf("/"));
              let name = x[x.length-1];
              console.log(filepath + " - "+ name);
              this.file.readAsArrayBuffer(filepath, name).then( success => {
                console.log(success);
                let blob = new Blob([success], {type: "video/mp4"});
                console.log(blob);

                
              });      
            }, err => {
              this.loadingProvider.hide();
              console.log("Media Err = "+err);
            });
    });
  }

  uploadVideoMessage(conversationId): Promise<any> {
    return new Promise(resolve => {
      this.loadingProvider.show();
          this.mediaCapture.captureVideo().then( data => {
              console.log(":::::DATA FROM captureVideo()");
              console.log(data);

              let videoUrl = 'file://' +data[0].fullPath;
              if(this.platform.is('ios')) {
                  videoUrl = 'file://' +data[0].fullPath;
              } else {
                  videoUrl = data[0].fullPath;
              }

              console.log("video path: "+videoUrl);
              let x = videoUrl.split("/");
              let filepath = videoUrl.substring(0,videoUrl.lastIndexOf("/"));
              let name = x[x.length-1];
              console.log(filepath + " - "+ name);
              this.file.readAsArrayBuffer(filepath, name).then( success => {
                console.log("this.file.readAsArrayBuffer => function execute")
                //console.log(success);
                let blob = new Blob([success], {type: "video/mp4"});
                //console.log(blob);
                // let timestamp = (Math.floor(Date.now() / 1000)).toString();

              });
            }, err => {
              this.loadingProvider.hide();
              console.log("Media Err = "+err);
            });
    });
  }

  downloadPhoto(url: any) {

      let storageDirectory = '';

      if(!this.platform.is('cordova')) {
          return false;
      }

      if (this.platform.is('ios')) {
          storageDirectory = this.file.documentsDirectory;
      }
      else if(this.platform.is('android')) {

          this.file.createDir(this.file.externalDataDirectory, 'TeamApp', true).then((result)=>{

              console.log("Directory created"+result);
          });

          storageDirectory = this.file.externalDataDirectory+ 'TeamApp/';
          console.log(storageDirectory);
      }
      else {
          // exit otherwise, but you could add further types here e.g. Windows
          return false;
      }

      const fileTransfer: FileTransferObject = this.transfer.create();
      fileTransfer.download(url, storageDirectory + this.generateFilename()).then((entry) => {
          let toast = this.toastCtrl.create({
              message: 'Success',
              duration: 3000,
              position: 'top'
          });

          toast.present();
      }, (error) => {
          let toast = this.toastCtrl.create({
              message: 'Error',
              duration: 3000,
              position: 'top'
          });

          toast.onDidDismiss(() => {
              console.log('Dismissed toast');
          });

          toast.present();
      });

  }

  downloadVideo(url: any) {
      //const fileTransfer: FileTransferObject = this.transfer.create();
  }
}



// WEBPACK FOOTER //
// ./src/providers/image.ts